import styled, { RuleSet } from 'styled-components'

import { PlainLink } from 'components/presentational/link'
import { VisuallyHiddenCss } from 'components/presentational/VisuallyHidden'

export const StyledSharingItemWrapper = styled(PlainLink)`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  outline: 0;
`
export const StyledSharingSvgWrapper = styled.div`
  ${(props) => props.theme.marginRight}: 10px;
`

export const StyledSharingTooltipDefaultContentItem = styled.div`
  padding: 4px 0;
  font-size: 16px;
  line-height: 24px;
  min-width: 160px;
`
interface StyledSharingContentWrapperProps {
  alignmentStyleCss?: RuleSet<object>
}
export const StyledSharingContentWrapper = styled.div<StyledSharingContentWrapperProps>`
  position: absolute;
  ${(props) => props.alignmentStyleCss};
  min-width: 240px;
`
export const TextAreaVisuallyHidden = styled.textarea`
  ${VisuallyHiddenCss};
  user-select: none;
  opacity: 0.1;
  -webkit-user-modify: read-write-plaintext-only;
  top: -9999px;
  left: 0;
`
